import { AuditCard } from "@/features/Audit/AuditCard";
import i18n from "@/i18n";
import { useParams } from "react-router-dom";
import { K2StaticDatumsEditCard } from "./edit_card";

const client = "k2";
const table_name = "k2_static_data";

export const K2StaticDatumsEdit = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <K2StaticDatumsEditCard
          id={Number(id)}
          client={client}
          table_name={table_name}
        />
        <AuditCard
          id={Number(id)}
          client={client}
          audit_table_name={table_name}
        />
      </div>
    </div>
  );
};
